// extracted by mini-css-extract-plugin
module.exports = {"drawer":"Menu_drawer__3BiG5","drawerPaper":"Menu_drawerPaper__1O9jZ","hideDrawer":"Menu_hideDrawer__2xoFG"};